import React, { ReactNode } from "react";
import { Dialog } from "..";
import "./confirmation-bar-dialog.css";
import { AcceptCancelConfirmationBar } from "../../confirmation-bar";

export const ConfirmationBarDialog = ({
	children,
	onOk,
	onCancel,
}: {
	children: ReactNode;
	onOk: () => void;
	onCancel: () => void;
}) => {
	return (
		<Dialog fullScreen className="confirmation-bar-dialog__container">
			{children}
			<AcceptCancelConfirmationBar
				className={"confirmation-bar-dialog__confirmation-bar"}
				onAccept={onOk}
				onCancel={onCancel}
			/>
		</Dialog>
	);
};

ConfirmationBarDialog.displayName = "ConfirmationBarDialog";
